import {Button, Stack, Typography} from '@mui/material';
import {AlertModal} from 'presentation/components';
import {RefundEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {RefundNotFoundModalProps} from './types';

const {notice} = translations['pt-br'].commons;
const defaultContent =
	translations['pt-br'].privateFlow.refund.additionalDocuments.refundNotFoundModal;

const {backButton, goToConsultRefund} =
	translations['pt-br'].privateFlow.refund.additionalDocuments;

export const RefundNotFoundModal = ({
	open,
	setOpen,
	title = defaultContent.title,
	description = defaultContent.description,
	description2 = defaultContent.description2,
	reversedFooter = false,
}: RefundNotFoundModalProps) => {
	const navigate = useNavigate();

	const handleNavigate = () => {
		navigate(RefundEnum.CONSULT);
	};

	return (
		<AlertModal
			open={open}
			headerTitle={notice}
			title={title}
			description={description}
			subDescription={
				<Typography variant="body1" textAlign="center">
					{description2}
				</Typography>
			}
			onClose={() => setOpen(prev => !prev)}
			variant="info"
			footerContent={
				<Stack gap={1} sx={{width: '100%'}}>
					{reversedFooter ? (
						<>
							<Button
								fullWidth
								size="large"
								variant="contained"
								onClick={() => setOpen(prev => !prev)}>
								{backButton}
							</Button>
							<Button fullWidth size="large" variant="outlined" onClick={handleNavigate}>
								{goToConsultRefund}
							</Button>
						</>
					) : (
						<>
							<Button fullWidth size="large" variant="outlined" onClick={handleNavigate}>
								{goToConsultRefund}
							</Button>
							<Button
								fullWidth
								size="large"
								variant="contained"
								onClick={() => setOpen(prev => !prev)}>
								{backButton}
							</Button>
						</>
					)}
				</Stack>
			}
		/>
	);
};
